/**************************************************************************************************/
/*   File: /src/app/shared/models/spatial.data.ts                                                 */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Tuesday February 19th 2019                                                     */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Mon Apr 01 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { SpatialDataTypeEnum } from '../enums';
import { LocalDocument } from './local.document';

/**
 * The spatial data metainfo
 */
export class SpatialData {
    /**
     * The creation date
     */
    creationDate: Date;
    /**
     * The data type
     */
    spatialDataType: SpatialDataTypeEnum;
    /**
     * True if is shapefile
     */
    systemCompatible: boolean;
    /**
     * The document
     */
    userContent: LocalDocument;
    /**
     * The system generated content
     */
    systemContent?: LocalDocument;

}